import React, { useState, useEffect } from "react";

//function library
import {
  capitalizeFirstLetter,
  getPriorityLabel,
  getPriorityClass,
  getStatusClass,
} from "../../../controller/global.function.library";

//styling
import "./ProjectModalForm.scss";

const ProjectModalForm = ({
  isFormEditMode,
  setIsFormEditMode,
  isVisible,
  onClose,
  projectData,
  setProjectData,
  handleInputChange,
  handleProjectFormEntry,
  errorMessage,
}) => {
  if (!isVisible) return null;

  //when create new Project is pressed, automatically set isEditMode false.

  const handleEditClick = () => {
    setIsFormEditMode(true);
  };

  const handleSaveClick = async (event) => {
    event.preventDefault();
    await handleProjectFormEntry();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="side-modal" onClick={(e) => e.stopPropagation()}>
        <button className="cancel-button" onClick={onClose}>
          X
        </button>
        <h3>
          {
            projectData.id // If the project already exists (has an ID)...
              ? isFormEditMode // ...then check if we're editing it
                ? "Update Project Details" // if edit mode -> show "Edit Project Details"
                : "Project Details" // else -> show "Project Details"
              : "Create New Project" // if no ID -> show "Create New Project"
          }
        </h3>

        {/* ---------- VIEW Form ---------- */}
        {!isFormEditMode && (
          <div className="modal-view">
            <div className="view-row">
              <label>Project Name</label>
              <div className="view-field">{projectData.name || "-"}</div>
            </div>

            <div className="view-row">
              <label>Description</label>
              <div className="description-view">
                {projectData.description || "-"}
              </div>
            </div>

            <div className="view-row">
              <label>Priority Strength</label>
              <p
                className={`project-form-priority ${getPriorityClass(
                  projectData.priority,
                )}`}
              >
                {getPriorityLabel(projectData.priority)}
              </p>
            </div>

            <div className="view-row">
              <label>Tag Label</label>
              <div className="project-form-label">
                {projectData.tag && projectData.tag.trim() !== ""
                  ? capitalizeFirstLetter(projectData.tag)
                  : "-"}
              </div>
            </div>

            <div className="view-row">
              <label> Status </label>
              <div
                className={`project-form-status-tag ${getStatusClass(
                  projectData.status,
                )}`}
              >
                {projectData.status}
              </div>
            </div>

            <div className="modal-actions">
              <button
                className="edit-button"
                type="button"
                onClick={handleEditClick}
              >
                Edit
              </button>
            </div>
          </div>
        )}

        {/* ---------- EDIT Form ---------- */}
        {isFormEditMode && (
          <form className="modal-form">
            <label className="project-modal-form-label">
              Project Name <span>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={projectData.name}
              onChange={handleInputChange}
              placeholder="Enter project name"
            />
            {/* <small className="custom-required-text">Required</small> */}
            <label className="project-modal-form-label">
              Description <small> (Optional) </small>
            </label>
            <textarea
              name="description"
              value={projectData.description}
              onChange={handleInputChange}
              placeholder="Enter project description"
            ></textarea>
            <small className="custom-required-text">Required</small>
            <label>Priority Strength: {projectData.priority}</label>
            <input
              className="slider-input"
              type="range"
              name="priority"
              min="1"
              max="10"
              step="1"
              value={projectData.priority}
              onChange={handleInputChange}
            />
            <label>Tag Label</label>
            {/* Work */}
            <div className="tag-line">
              <button
                type="button"
                className={`tag-chip work ${
                  projectData.tag === "Work" ? "active" : ""
                }`}
                onClick={() =>
                  setProjectData((previousData) => ({
                    ...previousData,
                    tag: "Work",
                  }))
                }
              >
                Work
              </button>

              {/* Personal */}
              <button
                type="button"
                className={`tag-chip personal ${
                  projectData.tag === "Personal" ? "active" : ""
                }`}
                onClick={() =>
                  setProjectData((previousData) => ({
                    ...previousData,
                    tag: "Personal",
                  }))
                }
              >
                Personal
              </button>

              {/* Custom */}
              <button
                type="button"
                className={`tag-chip custom ${
                  projectData.tag !== "Work" && projectData.tag !== "Personal"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setProjectData((previousData) => ({
                    ...previousData,
                    tag: "",
                  }))
                } // select Custom
              >
                Custom
              </button>

              {/* Show input if Custom selected */}
              {projectData.tag !== "Work" && projectData.tag !== "Personal" && (
                <div className="custom-input-wrapper">
                  <input
                    type="text"
                    name="tag"
                    value={projectData.tag}
                    onChange={handleInputChange}
                    placeholder="Enter a custom tag "
                    className="custom-tag-input"
                    autoFocus
                  />
                </div>
              )}
            </div>
            <label>Status</label>
            <select
              name="status"
              value={projectData.status}
              onChange={handleInputChange}
            >
              <option value="Not Started">Not Started</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="On Hold">On Hold</option>
            </select>
            {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
            <div className="modal-actions">
              <button
                type="submit"
                className="save-button"
                onClick={handleSaveClick}
              >
                Save
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ProjectModalForm;
